import { render, staticRenderFns } from "./BattleInfoLarge.vue?vue&type=template&id=991c7094&scoped=true&"
import script from "./BattleInfoLarge.vue?vue&type=script&lang=ts&"
export * from "./BattleInfoLarge.vue?vue&type=script&lang=ts&"
import style0 from "./BattleInfoLarge.vue?vue&type=style&index=0&id=991c7094&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991c7094",
  null
  
)

export default component.exports